import { render, staticRenderFns } from "./TenantMenuView.vue?vue&type=template&id=67210277&scoped=true&"
import script from "./TenantMenuView.vue?vue&type=script&lang=js&"
export * from "./TenantMenuView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67210277",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67210277')) {
      api.createRecord('67210277', component.options)
    } else {
      api.reload('67210277', component.options)
    }
    module.hot.accept("./TenantMenuView.vue?vue&type=template&id=67210277&scoped=true&", function () {
      api.rerender('67210277', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/sysMenu/TenantMenuView.vue"
export default component.exports